import { createContext, useEffect, useState } from 'react'
import { useLocation, useNavigate } from 'react-router-dom'

export const UTMContext = createContext({})

export function UTMProvider({ children }) {
  const location = useLocation()
  const navigate = useNavigate()
  const [utm, setUtm] = useState({})

  // 1️⃣ Captura e persiste UTMs
  useEffect(() => {
    const params = new URLSearchParams(location.search)

    const incomingUtm = {
      utm_source: params.get('utm_source'),
      utm_medium: params.get('utm_medium'),
      utm_campaign: params.get('utm_campaign'),
      utm_content: params.get('utm_content'),
      utm_term: params.get('utm_term'),
    }

    const hasUtm = Object.values(incomingUtm).some(Boolean)

    if (hasUtm) {
      setUtm(incomingUtm)
      sessionStorage.setItem('utm', JSON.stringify(incomingUtm))
    } else {
      const saved = sessionStorage.getItem('utm')
      if (saved) setUtm(JSON.parse(saved))
    }
  }, [location.search])

  // 2️⃣ Atualiza a URL interna com UTMs
  useEffect(() => {
    if (!Object.values(utm).some(Boolean)) return

    const currentParams = new URLSearchParams(location.search)
    const hasAllUTMs = Object.keys(utm).every(key => currentParams.has(key))

    // Atualiza a URL interna se faltar algum UTM
    if (!hasAllUTMs) {
      const newParams = new URLSearchParams(location.search)
      Object.entries(utm).forEach(([key, value]) => {
        if (value) newParams.set(key, value)
      })
      navigate(`${location.pathname}?${newParams.toString()}`, { replace: true })
    }
  }, [utm, location.pathname, location.search, navigate]) 

  // 2️⃣ Propaga UTMs automaticamente nos links
  useEffect(() => {
    if (!Object.values(utm).some(Boolean)) return

    const links = document.querySelectorAll('a[href]')

    links.forEach(link => {
      // ignora âncoras e links internos do React Router
      if (
        link.getAttribute('href').startsWith('#') ||
        link.getAttribute('href').startsWith('/')
      ) return

      const url = new URL(link.href)

      Object.entries(utm).forEach(([key, value]) => {
        if (value && !url.searchParams.has(key)) {
          url.searchParams.set(key, value)
        }
      })

      // Hotmart / Kiwify (sck)
      if (url.hostname.includes('hotmart') || url.hostname.includes('kiwify')) {
        const sck = Object.values(utm).filter(Boolean).join('-')
        if (!url.searchParams.has('sck')) {
          url.searchParams.set('sck', sck)
        }
      }

      link.href = url.toString()
    })
  }, [utm, location.pathname])

  return (
    <UTMContext.Provider value={utm}>
      {children}
    </UTMContext.Provider>
  )
}